import { Phone, Mail, MapPin, MessageCircle } from 'lucide-react';

const Contact = () => {
  return (
    <div className="min-h-screen bg-[#F9F9F7]">
      <div className="bg-white border-b border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold mb-4" data-testid="contact-page-title">Contact Us</h1>
          <p className="text-[#4A4A4A] max-w-2xl">
            Get in touch with our team for inquiries, quotes, or project consultations
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Information */}
          <div>
            <h2 className="font-heading text-2xl font-bold mb-6">Get in Touch</h2>
            <p className="text-[#4A4A4A] mb-8">
              Whether you're planning a residential project or need commercial lighting solutions,
              our team is here to help you find the perfect lighting for your space.
            </p>

            <div className="space-y-6">
              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#BFA15F] rounded-full flex items-center justify-center flex-shrink-0">
                  <Phone className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Phone & WhatsApp</h3>
                  <p className="text-[#4A4A4A]">+977-9816315999</p>
                  <a
                    href="https://wa.me/9779816315999"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#BFA15F] hover:underline text-sm inline-flex items-center gap-1 mt-1"
                    data-testid="whatsapp-contact-link"
                  >
                    <MessageCircle className="h-4 w-4" /> Chat on WhatsApp
                  </a>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#BFA15F] rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Email</h3>
                  <a
                    href="mailto:info@avexenterprises.com"
                    className="text-[#4A4A4A] hover:text-[#BFA15F] transition-colors"
                    data-testid="email-contact-link"
                  >
                    info@avexenterprises.com
                  </a>
                </div>
              </div>

              <div className="flex gap-4">
                <div className="w-12 h-12 bg-[#BFA15F] rounded-full flex items-center justify-center flex-shrink-0">
                  <MapPin className="h-6 w-6 text-white" />
                </div>
                <div>
                  <h3 className="font-semibold mb-1">Location</h3>
                  <p className="text-[#4A4A4A]">
                    Biratnagar, Nepal
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 p-6 bg-white border border-[#E5E5E5]">
              <h3 className="font-heading text-lg font-semibold mb-3">Business Hours</h3>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="text-[#888888]">Sunday - Friday</span>
                  <span className="font-medium">9:00 AM - 6:00 PM</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-[#888888]">Saturday</span>
                  <span className="font-medium">Closed</span>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form / Quick Links */}
          <div className="bg-white p-8 border border-[#E5E5E5]">
            <h2 className="font-heading text-2xl font-bold mb-6">Quick Actions</h2>
            
            <div className="space-y-4">
              <a
                href={`https://wa.me/9779816315999?text=${encodeURIComponent('Hello Avex Enterprises, I would like to inquire about your lighting products.')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full bg-[#25D366] text-white hover:bg-[#20BA5A] py-4 text-center uppercase tracking-widest text-sm font-medium transition-all duration-300"
                data-testid="quick-whatsapp-btn"
              >
                Message on WhatsApp
              </a>

              <a
                href="mailto:info@avexenterprises.com?subject=Product Inquiry&body=Hello Avex Enterprises,%0D%0A%0D%0AI would like to inquire about your lighting products."
                className="block w-full border border-[#1A1A1A] text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white py-4 text-center uppercase tracking-widest text-sm font-medium transition-all duration-300"
                data-testid="send-email-btn"
              >
                Send Email
              </a>

              <a
                href="tel:+9779816315999"
                className="block w-full border border-[#1A1A1A] text-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white py-4 text-center uppercase tracking-widest text-sm font-medium transition-all duration-300"
                data-testid="call-now-btn"
              >
                Call Now
              </a>
            </div>

            <div className="mt-8 p-6 bg-[#F9F9F7]">
              <h3 className="font-semibold mb-3">Services We Offer</h3>
              <ul className="space-y-2 text-sm text-[#4A4A4A]">
                <li>• Residential lighting consultation</li>
                <li>• Commercial lighting solutions</li>
                <li>• Custom lighting projects</li>
                <li>• Installation guidance</li>
                <li>• After-sales support</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;